
import { defineComponent } from 'vue'
import InputGroup from '@/components/layout/InputGroup.vue'

/**
 * 申請基本 権限エラー画面
 */
export default defineComponent({
  name: 'ProximityAuthError',
  components: {
    InputGroup,
  },
})
